import(/* webpackMode: "eager" */ "/var/www/gerelt/front/app/categories/page.js");
